import { render, staticRenderFns } from "./DashboardChicksUnborn.vue?vue&type=template&id=71548704&scoped=true"
import script from "./DashboardChicksUnborn.vue?vue&type=script&lang=js"
export * from "./DashboardChicksUnborn.vue?vue&type=script&lang=js"
import style0 from "./DashboardChicksUnborn.vue?vue&type=style&index=0&id=71548704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71548704",
  null
  
)

export default component.exports